// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__G46K8","clinicsSelect":"TableHeading_clinicsSelect__jdXGf"};